import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@deseretbook/react-ui'

const StyledClickableContent = styled('div')(
  ({
    theme,
    isPaddingless = false,
    isDisabled = false,
    color = 'background',
    shade = 'alternate',
  }) => {
    const additionalStyles = {}

    if (isDisabled) {
      additionalStyles.opacity = 0.5
      additionalStyles.cursor = 'not-allowed'
    }

    const backgroundColor = (theme.palette[color] && theme.palette[color][shade]) || color

    return {
      label: 'ClickableContent',
      padding: isPaddingless ? 0 : theme.spacing.use(0.5),
      display: 'block',
      textDecoration: 'none !important',
      cursor: 'pointer',
      borderRadius: '4px',
      ...additionalStyles,
      '&:hover': {
        backgroundColor,
      },
    }
  },
)

/**
 * Adds styles to say "this content is clickable". Can use the `as` prop to make the component
 * a link.
 *
 * @param {object} props - Component props
 * @returns {function} Component
 */
export const ClickableContent = ({ as, ...props }) => {
  const Component = as ? StyledClickableContent.withComponent(as) : StyledClickableContent

  return <Component {...props} />
}

ClickableContent.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
}

ClickableContent.defaultProps = {
  as: undefined,
}
